import { render } from "./DecoinExtract.vue?vue&type=template&id=44437f20&scoped=true&ts=true"
import script from "./DecoinExtract.vue?vue&type=script&lang=ts"
export * from "./DecoinExtract.vue?vue&type=script&lang=ts"

import "./DecoinExtract.vue?vue&type=style&index=0&id=44437f20&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44437f20"]])

export default __exports__